import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router-dom';
import { data as menuConfig } from 'configs/menu-config';
import { isManagerRestrictedPath } from 'helpers/role-access';

export const ProtectedRoute = ({ children }) => {
  const { user } = useSelector((state) => state.auth, shallowEqual);
  const { pathname } = useLocation();

  if (!user) {
    return <Navigate to='/login' replace />;
  }

  const routeSource = menuConfig[user?.role] || user?.urls || [];

  if (
    user?.role === 'manager' &&
    isManagerRestrictedPath(pathname, routeSource)
  ) {
    return <Navigate to='/dashboard' replace />;
  }

  return children;
};
